module.exports = __webpack_public_path__ + "media/img/clients/client2-562deca02da4ce413266238fd1930972.svg";